/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */
/* eslint-disable import/no-unresolved, import/default */

import entityTableTemplate from '../../table/entity-table.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

/*@ngInject*/
export default function CustomerSubscriptionRoutes($stateProvider, $injector) {

    var types = $injector.get('types');

    $stateProvider
        .state('home.customerSubscriptions', {
            url: '/customerSubscriptions',
            module: 'private',
            auth: [types.authority.PROVIDER_ADMIN.value, types.authority.PROVIDER_USER.value],
            views: {
                "content@home": {
                    templateUrl: entityTableTemplate,
                    controllerAs: 'vm',
                    controller: 'EntityTableController'
                }
            },
            data: {
                searchEnabled: false,
                pageTitle: 'customerSubscription.customerSubscriptions'
            },
            ncyBreadcrumb: {
                label: '{"icon": "subscriptions", "label": "customerSubscription.customerSubscriptions"}'
            },
            resolve: {
                entityTableConfiguration:
                /*@ngInject*/
                    function($stateParams, customerSubscriptionTableConfig) {
                        return customerSubscriptionTableConfig.getConfig($stateParams);
                    }
            }
        });
}



// WEBPACK FOOTER //
// ./src/app/customer/subscription/customer-subscription.routes.js